import { render, staticRenderFns } from "./BuildingEmissionCapChart.vue?vue&type=template&id=3606ae88&scoped=true"
import script from "./BuildingEmissionCapChart.vue?vue&type=script&lang=js"
export * from "./BuildingEmissionCapChart.vue?vue&type=script&lang=js"
import style0 from "./BuildingEmissionCapChart.vue?vue&type=style&index=0&id=3606ae88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3606ae88",
  null
  
)

export default component.exports